import { useState, useEffect, useCallback } from "react";
import DashboardLayout from "../../common/DashboardLayout";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import TeacherServices from "../../../services/TeacherServices";
import AdminServices from "../../../services/AdminServices";
import $ from "jquery";
import Swal from "sweetalert2";

const EditTeacher = () => {
  const navigate = useNavigate();

  const [params] = useSearchParams();
  const [info, setInfo] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
  });

  const teacher_id = params.get("teacher_id");

  useEffect(() => {
    // Don't fetch if teacher_id is not available yet
    if (!teacher_id) {
      return;
    }

    // Check if this is the school admin (shouldn't be editable as a teacher)
    const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
    const currentSchoolId = currentUser._id || currentUser.id;
    if (String(teacher_id) === String(currentSchoolId)) {
      Swal.fire({
        title: "Cannot Edit",
        text: "School admins cannot be edited as teachers. Please use the school settings to update your information.",
        icon: "warning",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/my-teachers");
      });
      return;
    }

    const fetchUser = async () => {
      try {
        console.log("Fetching teacher with ID:", teacher_id);
        const response = await TeacherServices.getTeacher(teacher_id);
        console.log("Teacher response:", response);

        // Parse address safely
        const addressParts = response.address ? response.address.split(",").map(part => part?.trim() || "") : [];
        
        // Parse name into firstName and lastName
        const fullName = (response.name || "").trim();
        const nameParts = fullName ? fullName.split(/\s+/) : [];
        const firstName = nameParts.length > 0 ? nameParts[0] : "";
        const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
        
        setInfo({
          id: response.id || response._id || "",
          firstName: firstName || "",
          lastName: lastName || "",
          email: response.email || "",
          address: addressParts[0] || "",
          city: addressParts[1] || "",
          state: addressParts[2] || "",
          zipCode: addressParts[3] || "",
        });
      } catch (error) {
        console.error("Error fetching teacher:", error);
        console.error("Error details:", {
          message: error?.message,
          response: error?.response?.data,
          status: error?.response?.status,
          teacher_id: teacher_id
        });
        const errorMessage = error?.response?.data?.error || error?.message || "Failed to load teacher information. Please try again.";
        Swal.fire({
          title: "Error!",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/my-teachers");
        });
      }
    };

    fetchUser();
  }, [teacher_id, navigate]);

  const handleEditSubmit = async () => {
    // Combine firstName and lastName into name for the backend
    const fullName = `${info.firstName.trim()} ${info.lastName.trim()}`.trim();
    const teacherData = {
      ...info,
      name: fullName,
    };
    
    const newTeacher = await TeacherServices.updateTeacher(teacherData);

    if (newTeacher) {
      Swal.fire({
        title: "Success!",
        text: "Teacher Edit successful !",
        icon: "success",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(-1);
        }
      });
    }
  };

  const userobj = JSON.parse(localStorage.getItem('user') || '{}');
  
  return (
    <DashboardLayout 
      role={1} 
      userType={userobj?.type}
      activeMenu="Edit Teacher"
      layoutType="topnav"
    >
                <div>
                  <div className="input-block">
                    <label className="form-control-label">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.firstName || ""}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, firstName: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.lastName || ""}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, lastName: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={info.email || ""}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, email: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.address || ""}
                      onChange={(e) =>
                        setInfo((prev) => ({
                          ...prev,
                          address: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.city || ""}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, city: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">State</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.state || ""}
                      onChange={(e) =>
                        setInfo((prev) => ({ ...prev, state: e.target.value }))
                      }
                      required
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">ZipCode</label>
                    <input
                      type="text"
                      className="form-control"
                      value={info.zipCode || ""}
                      onChange={(e) =>
                        setInfo((prev) => ({
                          ...prev,
                          zipCode: e.target.value,
                        }))
                      }
                      required
                    />
                  </div>

                  <div className="d-grid">
                    <button
                      className="btn btn-start"
                      onClick={handleEditSubmit}
                    >
                      Save
                    </button>
                  </div>

                  <hr className="my-4" />
                  <h5>Reset Password</h5>
                  <div className="input-block">
                    <label className="form-control-label">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="newPassword"
                      placeholder="Enter new password"
                      minLength={8}
                    />
                  </div>
                  <div className="input-block">
                    <label className="form-control-label">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      placeholder="Confirm new password"
                      minLength={8}
                    />
                  </div>
                  <div className="d-grid">
                    <button
                      className="btn btn-danger"
                      onClick={async () => {
                        const newPassword = document.getElementById("newPassword").value;
                        const confirmPassword = document.getElementById("confirmPassword").value;

                        if (!newPassword || !confirmPassword) {
                          return Swal.fire("Error", "Please fill in both password fields.", "error");
                        }
                        if (newPassword.length < 8) {
                          return Swal.fire("Error", "Password must be at least 8 characters.", "error");
                        }
                        if (newPassword !== confirmPassword) {
                          return Swal.fire("Error", "Passwords do not match.", "error");
                        }

                        try {
                          await AdminServices.resetUserPassword({
                            userId: info.id,
                            newPassword,
                            userType: "teacher",
                          });
                          document.getElementById("newPassword").value = "";
                          document.getElementById("confirmPassword").value = "";
                          Swal.fire("Success!", "Password has been reset.", "success");
                        } catch (error) {
                          Swal.fire("Error", error?.response?.data?.error || "Failed to reset password.", "error");
                        }
                      }}
                    >
                      Reset Password
                    </button>
                  </div>
                </div>
    </DashboardLayout>
  );
};

export default EditTeacher;
